import { Switch } from "@headlessui/react";
import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { IoStar } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";
import { fetchProviderDetails } from "../commonFunctions/CommonFunctions";

const ViewAllReviewCard = ({
  reviewData,
  setManualReviewModal,
  setReviewId,
  providerId,
}) => {
  // const { userName, date, rating, reviewText, isVisible, isManuallyAdded } =
  //   review;
  const {
    consumer_name,
    date_time,
    rating,
    review,
    status,
    id,
    isManuallyAdded,
  } = reviewData;

  const [enabled, setEnabled] = useState(status || false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const updateReviewStatus = async (newStatus, ratingId) => {
    setLoading(true);
    try {
      const response = await getApiCaller(
        `review_status?rating_id=${ratingId}&status=${newStatus ? 1 : 0}`
      );
      if (response.data?.status) {
        toast.success(response.data?.response_message);
        providerId && fetchProviderDetails(dispatch, providerId);
      } else {
        toast.error(response.data?.response_message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setEnabled(!newStatus); // Revert switch if API fails
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (ratingId) => {
    const newStatus = !enabled;
    setEnabled(newStatus);
    updateReviewStatus(newStatus, ratingId);
  };

  return (
    <>
      <div className="p-4 border rounded-lg shadow-sm mb-4">
        <div className="flex justify-between gap-3 mb-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-3">
              {/* <div className="rounded-full flex items-center justify-center font-semibold">
                <img
                  src={`https://c8.alamy.com/comp/KEDB24/handsome-young-man-profile-KEDB24.jpg`}
                  alt={"profile"}
                  className="w-11 h-11 rounded-xl"
                />
              </div> */}
              <div>
                <h3 className="font-semibold">{consumer_name}</h3>
                <p className="text-sm text-gray-500">{date_time}</p>
              </div>
            </div>
            <div className="flex space-x-1">
              <IoStar className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              <span className="font-semibold">{rating}</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {isManuallyAdded && (
              <div className="flex items-center gap-2">
                <p className="bg-[#E9F2FF] text-[#284184] px-3 py-1 rounded-lg">
                  Added Manually
                </p>
                <button
                  className="bg-[#4EBD71] p-1 rounded-lg"
                  onClick={() => {
                    setManualReviewModal(true);
                    setReviewId(1);
                  }}
                >
                  <CiEdit className="text-white text-xl" />
                </button>
              </div>
            )}
            <div className="flex items-center">
              <span className="text-sm font-semibold">
                Visible for consumer:
              </span>
              <div className=" flex gap-2 py-4 px-4">
                <p>OFF</p>
                {/* <Switch
                  checked={enabled}
                  onChange={() => setEnabled(!enabled)}
                  className="group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-[#284184]"
                >
                  <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
                </Switch> */}
                <Switch
                  checked={enabled}
                  onChange={() => handleSwitchChange(id)}
                  disabled={loading}
                  className={`group inline-flex h-6 w-11 items-center rounded-full ${
                    loading && enabled ? "justify-end" : "justify-start"
                  } transition ${
                    enabled ? "bg-[#284184] " : "bg-gray-200 justify-start"
                  }`}
                >
                  {loading ? (
                    <ClipLoader
                      size={20}
                      color="#ffffff"
                      loading={loading}
                      className={`${enabled ? "me-1" : "ms-1"} `}
                    />
                  ) : (
                    <span
                      className={`size-4 rounded-full bg-white transition ${
                        enabled ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  )}
                </Switch>
                <p>ON</p>
              </div>
            </div>
          </div>
        </div>
        <p className="text-gray-600 mb-4">{review}</p>
      </div>
    </>
  );
};

export default ViewAllReviewCard;
